import { Component, Event, EventEmitter, h, Listen, State } from '@stencil/core';
import store from '../../../helpers/store';
import { FlowSteps } from '../../../models/FlowSteps';
import { BaseComponent } from '../../base-component';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoFile from '../../../assets/landing/ico-file.svg';
import { FlowStatus } from '../../../models/FlowStatus';
import Events from '../../../helpers/Events';
import { db } from '../../../helpers/db';

@Component({
  tag: 'agreement-info',
  styleUrl: 'agreement-info.css',
  shadow: false,
})
export class AgreementInfo {
  @State() buttonDisabled: boolean;

  private translations: TranslationValues;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  async componentDidLoad() {
    await BaseComponent.initialize(FlowSteps.Agreements);
  }

  async componentWillLoad() {
    this.translations = await Translations.getValues();
    this.buttonDisabled = true;
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(FlowSteps.Agreements);
  }

  async buttonClick() {
    try {
      ApiCall.instance.GenerateAgreement('both');
      store.flowStatus = await ApiCall.instance.GetNextFlowState();
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  @Listen('atBottom')
  atBottomEmitted(data: any) {
    this.buttonDisabled = !data.detail;
  }

  async leaveFlow() {
    try {
      let abortResult = await ApiCall.instance.AbortRequest();
      store.flowStatus = FlowStatus[abortResult.state];

      await db.ectdata.delete(store.requestId);

      Events.flowAborted();
    } catch (e) {
      Events.flowAborted();
      this.apiErrorEvent.emit(e);
    }
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-1">
          <div class="mb-1 text-center">
            <img src={icoFile}></img>
          </div>
          <h1 class="text-center" innerHTML={this.translations.AgreementInfoValues.Title}></h1>

          <div style={{ height: '47vh' }}>
            <agreement-view agreementType="both"></agreement-view>
          </div>

          <div class="button flex mb-1 mx-3">
            <button class="main-button" disabled={this.buttonDisabled} onClick={() => this.buttonClick()}>
              {this.translations.AgreementCheckValues.ButtonYes}
            </button>
          </div>

          <div>
            <p class="main-text link-text text-center" onClick={() => this.leaveFlow()}>
              {this.translations.AgreementCheckValues.ButtonNo}
            </p>
          </div>

          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
